/**
 * Cliente del turno de conversación D-Talk contra la Function URL directa
 * (VITE_DTALK_MESSAGE_URL) — sin CloudFront, sin su timeout de 30s. Mismo
 * patrón que el chat del Brain. Si la env no está definida (stage viejo sin
 * redeploy de infra), el caller cae al procedure tRPC.
 */
import { fetchAuthSession } from 'aws-amplify/auth';

export interface DTalkMessageInput {
  message: string;
  idioma?: 'es' | 'pt' | 'en';
}

export interface DTalkMessageResult {
  reply: string;
  processStatus: string;
  notEligible: boolean;
  progressPct?: number;
  action?: unknown | null;
  eligibility?: { status: string; reason?: string };
}

export const DTALK_MESSAGE_URL: string | undefined = import.meta.env.VITE_DTALK_MESSAGE_URL;

export async function sendDTalkMessage(input: DTalkMessageInput): Promise<DTalkMessageResult> {
  if (!DTALK_MESSAGE_URL) throw new Error('VITE_DTALK_MESSAGE_URL no configurada');
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  const res = await fetch(DTALK_MESSAGE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`D-Talk: error ${res.status}`);
  return res.json();
}
